import React from 'react';
import { Card, CardHeader, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { useToast } from '@/components/ui/use-toast';
import { Mail, MessageCircle, Send } from 'lucide-react';

export default function Contact() {
  const { toast } = useToast();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // TODO: Implémenter l'envoi du message
    toast({
      title: "Message envoyé",
      description: "Nous vous répondrons dans les plus brefs délais.",
    });
  };

  return (
    <div className="min-h-screen pt-20 px-4 bg-gradient-to-br from-purple-50 via-pink-50 to-purple-100">
      <div className="max-w-2xl mx-auto space-y-6">
        <Card className="backdrop-blur-sm bg-white/90">
          <CardHeader>
            <div className="flex items-center gap-3 mb-2">
              <MessageCircle className="w-6 h-6 text-[#54075B]" />
              <h1 className="text-2xl font-bold">Contactez-nous</h1>
            </div>
            <p className="text-gray-600">
              Une question ? Un problème ? N'hésitez pas à nous contacter.
            </p>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Votre email
                </label>
                <input
                  type="email"
                  required
                  className="w-full px-3 py-2 border rounded-md focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  placeholder="vous@exemple.com"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Sujet
                </label>
                <select
                  required
                  className="w-full px-3 py-2 border rounded-md focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                >
                  <option value="">Sélectionnez un sujet</option>
                  <option value="technical">Problème technique</option>
                  <option value="account">Question sur mon compte</option>
                  <option value="diagnostic">Question sur le diagnostic</option>
                  <option value="other">Autre</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Votre message
                </label>
                <Textarea
                  required
                  className="min-h-[150px]"
                  placeholder="Décrivez votre question ou problème en détail..."
                />
              </div>

              <Button
                type="submit"
                className="w-full bg-[#54075B] hover:bg-[#54075B]/90 flex items-center justify-center gap-2"
              >
                <Send className="w-4 h-4" />
                Envoyer le message
              </Button>
            </form>

            <div className="mt-8 pt-8 border-t border-gray-200">
              <h2 className="text-lg font-semibold mb-4">Autres moyens de nous contacter</h2>
              
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <Mail className="w-5 h-5 text-[#54075B]" />
                  <a
                    href="mailto:solutions.oko@gmail.com"
                    className="text-[#54075B] hover:underline"
                  >
                    solutions.oko@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}